import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.externalLink)
      ? (_openBlock(), _createElementBlock("a", _mergeProps({
          key: 0,
          href: _ctx.externalLink
        }, _ctx.$attrs), [
          _renderSlot(_ctx.$slots, "default", {}, () => [
            _createTextVNode(_toDisplayString(_ctx.link.title), 1)
          ])
        ], 16, _hoisted_1))
      : _createCommentVNode("", true),
    (_ctx.internalLink)
      ? (_openBlock(), _createBlock(_component_router_link, _mergeProps({
          key: 1,
          to: _ctx.internalLink
        }, _ctx.$attrs), {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default", {}, () => [
              _createTextVNode(_toDisplayString(_ctx.link.title), 1)
            ])
          ]),
          _: 3
        }, 16, ["to"]))
      : _createCommentVNode("", true)
  ], 64))
}